import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		borderTopWidth: token('border.width'),
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

type Props = {
	children: React.ReactNode;
};

export const JsmCreateSurveyFooter = ({ children }: Props): React.JSX.Element => (
	<Inline xcss={styles.container} alignInline="end" alignBlock="center" space="space.100">
		{children}
	</Inline>
);
